import { render, staticRenderFns } from "./FornecedorCartao.vue?vue&type=template&id=021239a7&scoped=true"
import script from "./FornecedorCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./FornecedorCartao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FornecedorCartao.vue?vue&type=style&index=0&id=021239a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021239a7",
  null
  
)

export default component.exports